import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import modals from '../../../enums/modals';

import { wrapPromise } from '../../../utils/promise';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';
import useLoader from '../../../hooks/useLoader';
import { RECONSOLIDATION_PROCESS } from '../../../enums/loaderProcess';
import { onReconsolidateStops } from '../../../store/actions/stop';

export default () => {
  const dispatch = useDispatch();

  const { getModalRef } = useModalContext();
  const [showLoader, hideLoader] = useLoader();

  const handleConfirm = useCallback(
    async (reconsolidateStopData) => {
      showLoader(RECONSOLIDATION_PROCESS);
      await dispatch(onReconsolidateStops(reconsolidateStopData));
      hideLoader(RECONSOLIDATION_PROCESS);
    },
    [dispatch, hideLoader, showLoader]
  );

  const showReconsolidationNotice = useCallback(
    async (reconsolidateStopData, dismissCancel) => {
      const reconsolidationModalRef = getModalRef(
        modals.RECONSOLIDATION_NOTICE
      );
      const [result, canceled] = await wrapPromise(
        reconsolidationModalRef.current.showModal({
          info: reconsolidateStopData,
          autoConfirm: dismissCancel,
        })
      );
      if (canceled && !dismissCancel) {
        return;
      }
      handleConfirm(reconsolidateStopData);
    },
    [getModalRef, handleConfirm]
  );

  return {
    openReconsolidationNoticeModal: showReconsolidationNotice,
  };
};
